import React, { FunctionComponent, useState } from "react";

import Refine from "components/page/browse/refine";
import ShowGeolocator from "components/page/browse/show-geolocator";
import ListResults from "./list";
import useKeyPress from "@/use-key-press";
import ShowHideListButton from "./show-hide-list-button";

const Browse: FunctionComponent<ListProps> = ({ onShowGeolocate }) => {
  const [isListForced, setIsListForced] = useState(false);

  useKeyPress("Escape", "keydown", onShowGeolocate);

  return (
    <>
      <div
        id="sidebar"
        className="tw-bg-white-50 tw-w-96 tw-flex-col tw-space-y-2 tw-overflow-y-auto tw-h-min 2xl:tw-h-full @4xl/main:tw-h-full"
      >
        <div id="header" className="tw-sticky tw-top-0 tw-pointer-events-auto">
          <div className="tw-flex tw-flex-row">
            <ShowHideListButton
              className="tw-block 2xl:tw-hidden @4xl/main:tw-hidden"
              isShown={isListForced}
              onClick={() => setIsListForced(!isListForced)}
            />
            <ShowGeolocator onClick={() => onShowGeolocate()} />
          </div>
        </div>
        <div
          className={`${
            isListForced === false ? "tw-hidden" : ""
          } 2xl:tw-block @4xl/main:tw-block tw-bg-white tw-pointer-events-auto`}
        >
          <div className="tw-border-b tw-border-gray-300 tw-flex tw-flex-row tw-justify-start">
            <div className="tw-w-fit">
              <Refine />
            </div>
          </div>
          <ListResults />
        </div>
        {isListForced === false && (
          <footer
            className="tw-block 2xl:tw-hidden tw-absolute tw-bottom-0 tw-left-0 tw-w-full tw-bg-white tw-p-4 tw-pv-2"
            aria-label="Legend"
          >
            <dl className="tw-flex tw-flex-row tw-place-items-center">
              <dd className="tw-flex tw-flex-row tw-place-items-center">
                <img
                  src="//cdn.alpacamaps.com/nrma/ampol-member-benefits/discounts-icon.png"
                  alt="Fuel discount icon"
                  className="tw-mr-1"
                  width="18"
                  height="18"
                />
                <div className="tw-flex-grow">
                  <h3 className="tw-font-header tw-text-ellipsis">
                    My NRMA Fuel discount
                  </h3>
                </div>
              </dd>
            </dl>
          </footer>
        )}
      </div>
    </>
  );
};

export type ListProps = {
  onShowGeolocate: VoidFunction;
};

export default React.memo(Browse);
